import PageWrapperComponent from "@src/components/organisms/page-wrapper/page-wrapper.component";
import DataGridComponent from "@molecules/data-grid/data-grid.component";
import FeatherIcon from "feather-icons-react";
import PageHeadComponent from "@src/components/organisms/page-head/page-head.component";
import ToolTipComponent from "@atoms/tooltip/tooltip.component";
import { getBugDataByStatusApi } from "./bug-tracker-list.component.service";

function BugTrackerListTemplateComponent({
  templateModal: {
    tableTitle,
    keyColumn,
    breadCrumbs,
    tableColumn,
    tableData,
    totalCount,
    filters,
    tableParams,
    tableActions,
  },
  templateEvents: {
    getBugData,
    handleCreateClick,
    deleteRecords,
    submitFilter,
    handleDownload,
    handleReleaseClick,
  },
}) {
  const settingFormEdit = `${breadCrumbs[0].menu_url}/edit`;

  const ActionContent = ({ handleCreateClick }) => {
    return (
      <>
        <button
          type="button"
          className="btn btn-outline-primary btn-sm"
          onClick={handleCreateClick}
          style={{ marginRight: 10 }}
        >
          <FeatherIcon icon="plus" size={17} />
          &nbsp;
        </button>
        <ToolTipComponent content={"Release"}>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={handleReleaseClick}
            style={{ marginRight: 10 }}
          >
            <FeatherIcon icon="check-square" size={17} />
            &nbsp;
          </button>
        </ToolTipComponent>
      </>
    );
  };

  return (
    <PageWrapperComponent>
      <PageHeadComponent
        title={"All Bugs"}
        breadCrumbs={breadCrumbs}
        actionContent={<ActionContent handleCreateClick={handleCreateClick} />}
      />
      <DataGridComponent
        title={tableTitle}
        keyColumn={keyColumn}
        tableData={tableData}
        tableColumn={tableColumn}
        totalCount={totalCount}
        dataRefresh={getBugData}
        editLink={settingFormEdit}
        deleteRecords={deleteRecords}
        breadCrumbs={breadCrumbs}
        filters={filters}
        submitFilter={submitFilter}
        handleDownload={handleDownload}
        tableParams={tableParams}
        tableActions={tableActions}
      />
    </PageWrapperComponent>
  );
}

export default BugTrackerListTemplateComponent;
